import { render, staticRenderFns } from "./SendReporting.vue?vue&type=template&id=164aaf76"
import script from "./SendReporting.vue?vue&type=script&lang=js"
export * from "./SendReporting.vue?vue&type=script&lang=js"
import style0 from "./SendReporting.vue?vue&type=style&index=0&id=164aaf76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports